import { combineReducers } from 'redux';

import dashboard from './dasboard';
import modal from './modal';

export default combineReducers({
  dashboard,
  modal,
});
